import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

export const NoCollectionsFound = () => {
  return (
    <Tailwind
      style={{
        height: '100%',
        width: '100%',
      }}>
      <div className="flex flex-col items-center p-60">
        <div className="mb-16 flex h-80 w-80 items-center justify-center rounded-full bg-teal-300/[0.48]">
          <Icon
            name="lightbulb-info"
            className="h-[33.33px] w-[33.33px] text-teal-500"
          />
        </div>
        <div className="text-2xl font-semibold">No collections found</div>
        <div className="mt-8 text-center text-lg font-normal leading-[1.575rem] text-moon-750">
          There are no matching results for your search.
        </div>
      </div>
    </Tailwind>
  );
};
